import Parser from 'html-react-parser';
import l from '../../../../lang';
import { usePaymentIntegration } from '../../../../store/payment-integration';
import { DetailsOpened } from '../../../../store/payment-integration/interfaces';
import { ReactComponent as FenicioIcon } from '../../../../assets/icons/integrations/fenicio.svg';
import IntegrationDetails from '../integration-details';
import { Button } from '../../../common/button';
import { openNewTabAndFocus, getLanguage } from '../../../../utils';
import { Urls } from '../../../../config/urls';

export default () => {
  const { setDetailsOpened } = usePaymentIntegration();

  return (
    <IntegrationDetails icon={<FenicioIcon />} color="light-blue" onClose={() => setDetailsOpened(DetailsOpened.NONE)}>
      <div className="integration_details__title">{l('paymentIntegration.fenicio.details.headline')}</div>
      <p>
        <span>{Parser(l('paymentIntegration.fenicio.details.description'))}</span>
      </p>
      <Button
        className="integration_details__button"
        onClick={() => {
          openNewTabAndFocus(Urls.docs.teaserIntegrations[getLanguage()]);
        }}
      >
        {l('paymentIntegration.card.integration.voting.link')}
      </Button>
    </IntegrationDetails>
  );
};
